import React from 'react';
import Text from 'Components/Text';
import moment from 'moment';
import { STATUS } from 'constants/index';
import { Input, inputStyleClasses } from 'Components/Input';
import DatePicker from 'Components/DatePicker';
import Select from 'Components/Select';
import { INSPECTION_STATUS } from 'constants/index';

export default function GeneralInformation({
  user,
  status,
  description,
  inspectionDate,
  year,
  yearList,
  errors,
  handleInputChange,
  handleYearSelect,
  handleInspectionDateChange,
  approvalDate,
  address,
  manufacturerAddressesWithCurrent,
}) {
  const _isCanEditDescription = () => {
    if (user.isInternal()) return true;
    if (user.isInspector() && status !== STATUS.COMPLETE) return true;
  };

  const _isCanEditInspectionDate = () => {
    if (user.isInternal() || user.isInspector()) {
      if (status !== STATUS.COMPLETE && status !== STATUS.PENDING) return true;
    }

    return false;
  };

  const _isCanEditModelYear = () => {
    if (user.isInternal() || user.isInspector()) {
      if (status !== STATUS.COMPLETE && status !== STATUS.PENDING) return true;
    }

    return false;
  };

  const _isCanEditAddressField = () => {
    return !!((user.isInternal() || user.isInspector()) && status == STATUS.INCOMPLETE);
  };

  const _getDescription = () => {
    if (_isCanEditDescription()) {
      return (
        <Input
          mainWrapperClassName='_width_pc_100'
          styleClass={inputStyleClasses.primary}
          label='Description *'
          maxLength={250}
          alwaysTextField
          error={errors.description}
          value={description}
          onChange={handleInputChange('description')}
        />
      );
    } else {
      return (
        <Text
          mainWrapperClassName='text__wrapper_primary _width_pc_100'
          textClassName='text__text_primary'
          label='Description'
          value={description}
        />
      );
    }
  };

  const _getInspectionDate = () => {
    if (_isCanEditInspectionDate()) {
      return (
        <DatePicker
          label='Inspection Date *'
          error={errors.inspectionDate}
          selectedDate={inspectionDate}
          mainWrapperClassName='input__main-wrapper_primary _margin_right_30 _margin_top_18'
          handleSelectDate={handleInspectionDateChange}
        />
      );
    } else {
      return (
        <Text
          mainWrapperClassName='text__wrapper_primary _margin_right_30'
          textClassName='text__text_primary'
          label='Inspection Date'
          value={moment(inspectionDate).local(true).format('MM / DD / YYYY')}
        />
      );
    }
  };

  const _getModelYearDate = () => {
    if (_isCanEditModelYear()) {
      return (
        <Select
          selectionList={yearList}
          defaultItem={year}
          mainWrapperClassName='input__main-wrapper_primary'
          type='primary'
          label='Model Year *'
          error={errors.year}
          handleSelect={handleYearSelect}
        />
      );
    } else {
      return (
        <Text
          mainWrapperClassName='text__wrapper_primary'
          textClassName='text__text_primary'
          label='Model Year'
          value={year}
        />
      );
    }
  };

  const _getAddressField = () => {
    if (_isCanEditAddressField()) {
      return (
        <Select
          selectionList={manufacturerAddressesWithCurrent}
          defaultItem={address}
          mainWrapperClassName='input__main-wrapper_primary _width_pc_100'
          type='primary'
          label='Select Address *'
          itemNameIndicator='name'
          error={errors.address}
          handleSelect={handleInputChange('address')}
        />
      );
    } else {
      return (
        <Text
          mainWrapperClassName='text__wrapper_primary _width_pc_100'
          textClassName='text__text_primary'
          label='Address'
          value={typeof address === 'object' ? address.name : address}
        />
      );
    }
  };

  return (
    <section className='scene_section _padding_top_0'>
      <header>General Info</header>
      {_getDescription()}
      {_getInspectionDate()}
      {_getModelYearDate()}
      {_getAddressField()}
      {status === INSPECTION_STATUS.COMPLETE && (
        <Text
          mainWrapperClassName='text__wrapper_primary  _width_pc_100'
          textClassName='text__text_primary'
          label='Approval date'
          value={approvalDate ? moment(approvalDate).local(true).format('MM / DD / YYYY') : 'N/A'}
        />
      )}
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/app/Scenes/Inspection/Edit/Report/GeneralInformation.jsx